module.exports = __webpack_public_path__ + "img/consent-collection-widget-centre.155ed5c1.svg";